/* eslint-disable camelcase */
import {
  listItemWrapper,
  listWrapper,
  pagedListWrapper,
  singleItemWrapper
} from '../../../api-client/wrappers'
import type { Starter } from '../../types/internal'
import type {
  MemberStatus,
  Task,
  DetailedTask,
  Activation,
  Condition,
  ConditionGroup,
  Category
} from './types'

export default {
  factory: ({ apiClient, version }, { module }) => {
    const { getItem: getTask } = listItemWrapper<DetailedTask>(apiClient, {
      path: `/api/v${version}/tasks`
    })

    const tasks = pagedListWrapper<'id', Task>()(apiClient, {
      path: `/api/v${version}/tasks`,
      idKey: 'id'
    })

    const { getItem: getPrivilegeTask } = listItemWrapper<DetailedTask>(
      apiClient,
      { path: `/api/v${version}/tasks/privilege` }
    )

    const { get: getPriorities } = singleItemWrapper<Task['id'][]>(apiClient, {
      path: `/api/v${version}/tasks/priorities`
    })

    const categories = listWrapper<'id', Category>(apiClient, {
      path: `/api/v${version}/task/categories`,
      idKey: 'id'
    })

    return {
      getTask,
      tasks,
      categories,
      getPrivilegeTask,
      getPriorities,

      unlockTask: (taskId: Task['id'], groupIndex: ConditionGroup['index']) =>
        apiClient.post<MemberStatus>(
          `/api/v${version}/tasks/${taskId}/unlock/${groupIndex}`
        ),

      cancelTask: (id: Task['id']) =>
        apiClient.post<MemberStatus>(`/api/v${version}/tasks/${id}/cancel`),

      activateTask: (token: string) =>
        apiClient.post<Activation>(
          `/api/v${version}/tasks/activation/${token}`
        ),

      upTask: (id: Task['id']) =>
        apiClient.post<MemberStatus>(`/api/v${version}/tasks/${id}/up`),

      manualCheckCondition: async ({
        id,
        event: { manual_check, manual_params }
      }: Condition) => {
        if (!manual_check) {
          throw new Error('This condition cannot be checked manually')
        }

        let body: Record<string, string> | undefined

        if (manual_params?.action === 'oauth') {
          const { popupWaitUrl, openWindow } = await module('auth')

          const authWindow = openWindow(manual_params.url, {
            features:
              'resizable=no,scrollbars=no,toolbar=no,menubar=no,location=no,directories=no,status=no',
            width: Math.min(Math.round(window.innerWidth * 0.7), 1210),
            height: Math.min(Math.round(window.innerHeight * 0.7), 650)
          })

          if (!authWindow) {
            throw new TypeError('Auth window is out of reach')
          }

          body = await popupWaitUrl(authWindow, manual_params.response)
          authWindow.close()
        }

        await apiClient.post(`/api/v${version}/tasks/conditions/${id}/manual`, {
          body
        })
      }
    }
  }
} satisfies Starter
